export default "__VITE_ASSET__0bab0353__"